import React from 'react';
import {createRoot} from "react-dom/client";
import JobOpportunity from "../../Components/Forms/JobOpportunity";

const form = document.getElementById('job-opportunity-form-container');
if (form) {
    createRoot(form).render(<JobOpportunity {...(form.dataset)} />);
}
